export default "__VITE_ASSET__BAMMNuL6__"